import { createAction, props } from '@ngrx/store';
import {
	CacheContextEnum,
	CacheContextKey,
	ICacheStats,
	IClearCacheRequest,
} from '../../service/cache/interface';
import { IResponseError } from '../../service/interface';

// ── API ──

const loadStats = createAction('[Cache/API] Load Stats');

const loadStatsSuccess = createAction(
	'[Cache/API] Load Stats Success',
	props<{
		contexts: Record<string, ICacheStats>;
		degradedContexts: CacheContextEnum[];
	}>(),
);

const loadStatsError = createAction(
	'[Cache/API] Load Stats Error',
	props<{ error: IResponseError }>(),
);

const loadContextStats = createAction(
	'[Cache/API] Load Context Stats',
	props<{ context: CacheContextKey }>(),
);

const loadContextStatsSuccess = createAction(
	'[Cache/API] Load Context Stats Success',
	props<{ context: CacheContextKey; stats: ICacheStats }>(),
);

const loadContextStatsError = createAction(
	'[Cache/API] Load Context Stats Error',
	props<{ error: IResponseError }>(),
);

const clearCache = createAction(
	'[Cache/API] Clear Cache',
	props<{ request: IClearCacheRequest }>(),
);

const clearCacheSuccess = createAction(
	'[Cache/API] Clear Cache Success',
	props<{ deletedCount: number }>(),
);

const clearCacheError = createAction(
	'[Cache/API] Clear Cache Error',
	props<{ error: IResponseError }>(),
);

// ── UI ──

const clearError = createAction('[Cache/UI] Clear Error');

export const CacheActions = {
	loadStats,
	loadStatsSuccess,
	loadStatsError,
	loadContextStats,
	loadContextStatsSuccess,
	loadContextStatsError,
	clearCache,
	clearCacheSuccess,
	clearCacheError,
	clearError,
};
